export default __webpack_public_path__ + "static/media/crypto.b7040e66.svg";